import { plural, t } from "@web-monorepo/i18n/macro";
import { DDSDisplayText } from "@web-monorepo/dds";
import { IconPlus } from "@web-monorepo/dds-icons";
import { logParentToolkitEvent } from "src/utils/logEvent";
import { formatTime } from "utils";
import styles from "./TimerOptions.module.css";
import TimerDurationButton from "./TimerDurationButton";

const times = [
  { seconds: 15, minutes: 0, loggingId: "15" },
  { seconds: 30, minutes: 0, loggingId: "30" },
  { seconds: 0, minutes: 1, loggingId: "1" },
  { seconds: 0, minutes: 5, loggingId: "5" },
  { seconds: 0, minutes: 10, loggingId: "10" },
  { custom: true, loggingId: "add" },
];

type TimerOptionsProps = {
  openTimer: (input: number) => void;
  openCustomModal: VoidFunction;
};

export default function TimerOptions({ openTimer, openCustomModal }: TimerOptionsProps) {
  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {times.map((time) => {
          const totalSeconds = (time.seconds || 0) + (time.minutes || 0) * 60;
          if (time.custom) {
            return (
              <TimerDurationButton
                key="custom"
                aria-label={t`Custom timer`}
                onClick={() => {
                  logParentToolkitEvent({ eventName: `timer.${time.loggingId}.tap` });
                  openCustomModal();
                }}
              >
                <IconPlus size="l" className={styles.addIcon} />
              </TimerDurationButton>
            );
          }
          return (
            <TimerDurationButton
              key={totalSeconds}
              aria-label={
                time.minutes
                  ? plural(time.minutes, { one: "# minute", other: "# minutes" })
                  : plural(totalSeconds, { one: "# second", other: "# seconds" })
              }
              onClick={() => {
                logParentToolkitEvent({ eventName: `timer.${time.loggingId}.tap` });
                openTimer(totalSeconds);
              }}
            >
              <DDSDisplayText level="md">{formatTime(totalSeconds)}</DDSDisplayText>
            </TimerDurationButton>
          );
        })}
      </div>
    </div>
  );
}
